import Konva from "konva";

class MaterialAlert {

    constructor(configurator) {
        this.configurator = configurator;
        this.sofa = configurator.sofa;
        this.configData = this.sofa.configData;
        this.hasInstance = false;
        this.group = new Konva.Group({
            x: configurator.containerWidth / 2 - 190,
            y: configurator.containerHeight / 2,
            width: 380,
            height: 126,
            name: 'materialAlert'
        });

        this.init()
    }

    init() {
        this.build();
    }

    show() {
        let object = this;
        object.configurator.layer.add(object.group);
        object.configurator.layer.draw();
    }

    hide() {
        let object = this;
        object.configurator.layer.findOne('.materialAlert').remove();
        object.configurator.layer.draw();
    }

    build() {

        let object = this;

        let bgImage = object.configData.materialAlertBg;

        let bg = new Konva.Image({
            x: 0,
            y: 0,
            width: 380,
            height: 126,
            image: bgImage,
            name: 'materialAlertBg'
        });

        let text = new Konva.Text({
            x: 46,
            y: 42,
            align: 'center',
            width: 273,
            lineHeight: 1.2,
            text: 'Визуализация данной ткани пока не доступна на сайте, но вы можете\n посмотреть ее в наших шоу-румах',
            fontSize: 16,
            fontFamily: 'Circe',
            fill: '#535353',
            name: 'materialAlertText'
        })

        let crossImage = object.configData.cross;
        let cross = new Konva.Image({
            x: 350,
            y: 30,
            width: 18,
            height: 18,
            image: crossImage,
            name: 'materialAlertCross'
        });

        cross.on('click', () => {
            object.hide();
        })
        
        object.group.add(bg);
        object.group.add(text);
        object.group.add(cross);
    }
}

export default MaterialAlert;